import { TextfieldValidation } from '@shared/abstraction/textfield-validation';

export function parseToTextfieldValidation(
  messages: JSONObject,
  label: string
): TextfieldValidation[] {
  const errorMessages: TextfieldValidation[] = [];

  Object.keys(messages).forEach((messageKey: string) => {
    const errorMessage = messages[messageKey]
      .toString()
      .replace(/%[a-zA-Z0-9]+%/g, label);

    const validation = {
      name: messageKey,
      invalid: false,
      errorMessage,
    };

    errorMessages.push(validation);
  });

  return errorMessages;
}
